module.exports = __webpack_public_path__ + "static/media/mono-promo.0f2cea24.webp";